import React from 'react'
import Link from 'redux-first-router-link'
import Menu from '@groovehq/internal-design-system/lib/components/Menu/Menu'
import {
  UserGroup,
  Negative,
} from '@groovehq/internal-design-system/lib/assets/icons'
import { buildSearchPath, constructSearchQueryString } from 'util/search'

import SearchRawCount from 'components/App/DesktopView/Layout/SearchRawCount'
import TagsMenuItem from 'subapps/ticketing/components/TagsMenuItem'
import AddUserDrawerLink from './AddUserDrawerLink'
import Item from '../Item'
import MoreFolderOptions from './MoreFolderOptions'
import FolderKindIcon from './FolderKindIcon'

class Mailbox extends React.PureComponent {
  componentDidMount = () => {
    const { toggleTeamSection, hasEverToggledTeamSection, agents } = this.props

    if (!hasEverToggledTeamSection && this.hasAtMostOneAgent(agents)) {
      // agent has never expanded teams section before and agents for mailbox <= 1
      // expand section to encourage adding new team member
      toggleTeamSection()
    }
  }

  hasAtMostOneAgent = agents => (agents || []).length <= 1

  buildMailboxPath = params => {
    const { mailbox, sortOrder } = this.props
    const isAllMailboxes = mailbox.id === null
    return buildSearchPath({ sortOrder, state: 'open' })(
      isAllMailboxes ? params : { ...params, mailbox: mailbox.id }
    )
  }

  buildMailboxFolderPath = params => {
    const { mailbox, sortOrder } = this.props
    const isAllMailboxes = mailbox.id === null
    return buildSearchPath({ sortOrder })(
      isAllMailboxes ? params : { ...params, mailbox: mailbox.id }
    )
  }

  buildMailboxQueryString = params => {
    const { mailbox } = this.props
    const isAllMailboxes = mailbox.id === null
    return constructSearchQueryString(
      isAllMailboxes
        ? params
        : {
            ...params,
            mailbox: mailbox.id,
          }
    )
  }

  render() {
    const {
      agents,
      mailbox,
      isCurrent,
      toggleTeamSection,
      toggleTagsSection,
      isTeamSectionOpen,
      isTagsSectionOpen,
      doOpenSearchPage,
      doStartSearchTimer,
      wantsCompactMode,
      isManager,
      activeAgentCount,
      onClick,
    } = this.props
    const folders = mailbox.folders
    const firstFolder = folders && folders[0]
    const firstFolderPath =
      firstFolder && this.buildMailboxFolderPath({ folder: firstFolder.id })
    const mailboxQueryId = this.buildMailboxQueryString({ is: 'open' })
    // Demo inbox should be considered as confirmed
    const isConfirmed = ['active', 'confirmed', 'demo'].includes(mailbox.state)
    // Make sure only show the unconfirmed or disconnected warning for channels that have state
    const shouldShowWarning =
      mailbox.state && mailbox.channel_type && !isConfirmed

    const teammatesItem = (
      <Menu.UnmanagedItem
        icon={<UserGroup />}
        open={isTeamSectionOpen}
        isSubMenuItem
        hasArrow
        onClick={toggleTeamSection}
        value="team-section"
        subMenu={
          <>
            {agents &&
              agents.map(agent => {
                return (
                  <Item
                    isSubMenuItem
                    agentId={agent.id}
                    key={agent.id}
                    value={agent.id}
                    name={agent.shortName}
                    doOpenSearchPage={doOpenSearchPage}
                    doStartSearchTimer={doStartSearchTimer}
                    displayCountWhenInactive
                    buildMailboxFolderPath={this.buildMailboxFolderPath}
                    buildMailboxQueryString={this.buildMailboxQueryString}
                  />
                )
              })}
            {isManager && (
              <AddUserDrawerLink
                isSubMenuItem
                highlight={this.hasAtMostOneAgent(agents)}
              />
            )}
          </>
        }
      >
        {app.t('Agents')}
      </Menu.UnmanagedItem>
    )

    const mailboxSubmenu = (
      <>
        {mailbox.folders.map(folder => {
          return (
            <Item
              icon={<FolderKindIcon kind={folder.kind} />}
              folderId={folder.id}
              key={folder.id}
              value={folder.id}
              name={folder.name}
              doOpenSearchPage={doOpenSearchPage}
              doStartSearchTimer={doStartSearchTimer}
              displayCountWhenInactive={folder.displayCountWhenInactive}
              hideIfZeroConversations={folder.hideIfZeroConversations}
              buildMailboxFolderPath={this.buildMailboxFolderPath}
              buildMailboxQueryString={this.buildMailboxQueryString}
              moreOptions={
                isManager && (
                  <Menu.Item.MoreOptions
                    overlay={
                      <MoreFolderOptions
                        id={folder.id}
                        isDefault={folder.default}
                      />
                    }
                    menuItemIconHidden
                  />
                )
              }
              isSubMenuItem
            />
          )
        })}
        {activeAgentCount > 1 && teammatesItem}
        <TagsMenuItem
          isTagsSectionOpen={isTagsSectionOpen}
          toggleTagsSection={toggleTagsSection}
          doOpenSearchPage={doOpenSearchPage}
          doStartSearchTimer={doStartSearchTimer}
          buildMailboxFolderPath={this.buildMailboxFolderPath}
          buildMailboxQueryString={this.buildMailboxQueryString}
        />
      </>
    )

    if (wantsCompactMode) {
      return mailboxSubmenu
    }

    return (
      <Menu.UnmanagedItem
        as={Link}
        dotColor={mailbox.color || 'color.monochrome.dark'}
        count={
          !shouldShowWarning && <SearchRawCount queryId={mailboxQueryId} />
        }
        onClick={onClick}
        to={firstFolderPath}
        open={isCurrent}
        subMenu={isCurrent && mailboxSubmenu}
        value="mailbox-section"
        // The negative margin is for offsetting the icon's whitespace,
        // so it can align well with other inboxes's count numbers
        extraIcon={shouldShowWarning && <Negative className="grui -mr-2" />}
        extraIconType="warning"
      >
        {mailbox.name}
      </Menu.UnmanagedItem>
    )
  }
}

export default Mailbox
